import { Disclosure, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { AnchorText } from '../../common';

const NavbarPrimaryMobileDropdownNavItem = ({ nav, page, sanity }) => {
  const { colors } = sanity;
  const dropdownTextLabel = nav?.dropdownTextLabel;
  const dropdownLabelLink = nav?.dropdownLabelLink;
  // If no explicit text label is provided and a label link exists, use its name.
  const label =
    dropdownTextLabel || (dropdownLabelLink ? dropdownLabelLink?.name : '');
  const dropdownItems = nav?.dropdown || [];

  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex flex-col justify-between w-full py-2 space-y-8 text-lg font-medium text-left rounded-lg">
            <li className="flex gap-x-2">
              {dropdownLabelLink && dropdownLabelLink?.slug?.current ? (
                <AnchorText
                  sanity={sanity}
                  type="internal"
                  color={colors?.neutral?.dark}
                  to={dropdownLabelLink.slug.current}
                >
                  {label}
                </AnchorText>
              ) : (
                <span style={{ color: colors?.neutral?.dark }}>{label}</span>
              )}
              <ChevronDownIcon
                aria-hidden="true"
                className={`${open ? 'rotate-180 transform' : ''} mt-1`}
              />
            </li>
          </Disclosure.Button>
          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="flex flex-col ml-4 space-y-8 text-lg font-medium text-left">
              {dropdownItems.map(({ singlePageLink }) => (
                <AnchorText
                  key={singlePageLink?.slug?.current}
                  sanity={sanity}
                  type="internal"
                  color={colors?.neutral?.default}
                  to={singlePageLink?.slug?.current}
                >
                  {singlePageLink?.name}
                </AnchorText>
              ))}
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
};

export { NavbarPrimaryMobileDropdownNavItem };
